import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './i18n';

import Full from './layouts/Full';
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';

// Auth
import Login from './page/Auth/Login';
import Logout from './page/Auth/Logout';
import Register from './page/Auth/Register';
import ForgotPassword from './page/Auth/ForgotPassword';
import AccountActivated from './page/Auth/AccountActivated';
import ChangePassword from './page/Auth/ChangePassword';

// ---------- Admin -------------

import Setting from './page/Admin/Setting/Setting';
import EmailSetting from './page/Admin/Setting/EmailSetting';
import CommonSetting from './page/Admin/Setting/CommonSetting';
import InvoiceSetting from './page/Admin/Setting/InvoiceSetting';
import ExcludingDomainsSetting from './page/Admin/Setting/ExcludingDomainsSetting';

import AdminDashboard from './page/Admin/Dashboard';

import UserRolesList from './page/Admin/UserRoles/UserRolesList';
import UserRoles from './page/Admin/UserRoles/UserRoles';

import AdminUserList from './page/Admin/AdminUser/UserList';
import AdminUser from './page/Admin/AdminUser/User';

import UserList from './page/Admin/User/UserList';
import UserView from './page/Admin/User/View';

import SubscriptionPlanList from './page/Admin/SubscriptionPlan/SubscriptionPlanList';
import SubscriptionPlan from './page/Admin/SubscriptionPlan/SubscriptionPlan';

import AdminInvoicesList from './page/Admin/Invoice/InvoicesList';
import AdminOrderList from './page/Admin/Order/OrderList';
import SubscriptionList from './page/Admin/Invoice/SubscriptionList';

import EnquiryList from './page/Admin/Enquiry/EnquiryList';



// ---------- User -----------
import Dashboard from './page/User/Dashboard';

import MyProfileSetting from './page/User/Profile/MyProfile';
import InvoicesList from './page/User/Profile/InvoicesList';
import MySubscription from './page/User/Profile/MySubscription';
import Support from './page/User/Setting/Support';
import UserSetting from './page/User/Setting/UserSetting';


import UnitsList from './page/User/Units/UnitsList';
import Units from './page/User/Units/Units';

import DepartmentsList from './page/User/Departments/DepartmentsList';
import Department from './page/User/Departments/Department';

import EmployeeList from './page/User/Employees/EmployeeList';
import Employee from './page/User/Employees/Employee';

import AttendanceList from './page/User/Attendance/AttendanceList';
import Attendance from './page/User/Attendance/Attendance';

import PaymentList from './page/User/Payment/PaymentList';
import Payment from './page/User/Payment/Payment';

import SalaryReports from './page/User/Reports/SalaryReports';
import EmployeeLaserReports from './page/User/Reports/EmployeeLaserReports';
import PayrollSummary from './page/User/Reports/PayrollSummary';
import LaserReports from './page/User/Reports/LaserReports';

import UpgradePlan from './page/User/UpgradePlan';


// ✅ Remove splash screen
const loader = document.getElementById("loader");
if (loader) {
  loader.style.display = "none";
}

function App() {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Full />,
            children: [
                {
                    path: "",
                    element: <Login />,
                },
                {
                    path: "signup",
                    element: <Register />,
                },
                {
                    path: "account-activated/:id",
                    element: <AccountActivated />,
                },
                {
                    path: "/forgot",
                    element: <ForgotPassword />,
                },
                {
                    path: "/logout",
                    element: <Logout />,
                }
            ],
        },
        {
            path: "/",
            element: <UserLayout />,
            children: [
                {
                    path: "dashboard",
                    element: <Dashboard />,
                },
                {
                    path: "change-password",
                    element: <ChangePassword />,
                },
                {
                    path: "upgrade-plan",
                    element: <UpgradePlan />,
                },
                {
                    path: "/profile",
                    children: [
                        {
                            path: "",
                            element: <MyProfileSetting />,
                        },
                        {
                            path: "invoices",
                            element: <InvoicesList />,
                        },
                        {
                            path: "my-subscription",
                            element: <MySubscription />,
                        },
                        {
                            path: "setting",
                            element: <UserSetting />,
                        }
                    ]
                },
                {
                    path: "units",
                    children: [
                        {
                            path: "",
                            element: <UnitsList />,
                        },
                        {
                            path: "add",
                            element: <Units />,
                        },
                        {
                            path: "edit/:id",
                            element: <Units />,
                        }
                    ]
                },
                {
                    path: "departments",
                    children: [
                        {
                            path: "",
                            element: <DepartmentsList />,
                        },
                        {
                            path: "add",
                            element: <Department />,
                        },
                        {
                            path: "edit/:id",
                            element: <Department />,
                        }
                    ]
                },
                {
                    path: "employees",
                    children: [
                        {
                            path: "",
                            element: <EmployeeList />,
                        },
                        {
                            path: "add",
                            element: <Employee />,
                        },
                        {
                            path: "edit/:id",
                            element: <Employee />,
                        }
                    ]
                },
                {
                    path: "payments",
                    children: [
                        {
                            path: "",
                            element: <PaymentList />,
                        },
                        {
                            path: "add",
                            element: <Payment />,
                        },
                        {
                            path: "edit/:id",
                            element: <Payment />,
                        }
                    ]
                },
                {
                    path: "attendance",
                    children: [
                        {
                            path: "",
                            element: <AttendanceList />,
                        },
                        {
                            path: "add",
                            element: <Attendance />,
                        },
                        
                    ]
                },
                {
                    path: "reports",
                    children: [
                        {
                            path: "salary",
                            element: <SalaryReports />,
                        },
                        {
                            path: "laser",
                            element: <LaserReports />,
                        },
                        {
                            path: "employee-laser",
                            element: <EmployeeLaserReports />,
                        },
                        {
                            path: "payroll",
                            element: <PayrollSummary />,
                        },
                    ]
                },
                {
                    path: "support",
                    children: [
                        {
                            path: "",
                            element: <Support />,
                        }
                    ]
                },

            ],
        }, {
            path: "/admin",
            element: <AdminLayout />,
            children: [
                {
                    path: "dashboard",
                    element: <AdminDashboard />,
                },
                {
                    path: "change-password",
                    element: <ChangePassword />,
                },
                {
                    path: "setting",
                    children: [
                        {
                            path: "",
                            element: <Setting />,
                        },
                        {
                            path: "email",
                            element: <EmailSetting />,
                        },
                        {
                            path: "common",
                            element: <CommonSetting />,
                        },
                        {
                            path: "invoice",
                            element: <InvoiceSetting />,
                        },
                        {
                            path: "excluding-domains",
                            element: <ExcludingDomainsSetting />,
                        },
                    ]
                },
                {
                    path: "user-roles",
                    children: [
                        {
                            path: "",
                            element: <UserRolesList />,
                        },
                        {
                            path: "add",
                            element: <UserRoles />,
                        },
                        {
                            path: "edit/:id",
                            element: <UserRoles />,
                        }
                    ]
                },
                {
                    path: "admin-users",
                    children: [
                        {
                            path: "",
                            element: <AdminUserList />,
                        },
                        {
                            path: "add",
                            element: <AdminUser />,
                        },
                        {
                            path: "edit/:id",
                            element: <AdminUser />,
                        }
                    ]
                },
                {
                    path: "users",
                    children: [
                        {
                            path: "",
                            element: <UserList />,
                        },
                        {
                            path: "view/:id",
                            element: <UserView />,
                        }
                    ]
                },
                {
                    path: "subscription-plan",
                    children: [
                        {
                            path: "",
                            element: <SubscriptionPlanList />,
                        },
                        {
                            path: "add",
                            element: <SubscriptionPlan />,
                        },
                        {
                            path: "edit/:id",
                            element: <SubscriptionPlan />,
                        }
                    ]
                },
                {
                    path: "subscription",
                    children: [
                        {
                            path: "",
                            element: <SubscriptionList />,
                        }
                    ]
                },
                {
                    path: "invoices",
                    children: [
                        {
                            path: "",
                            element: <AdminInvoicesList />,
                        }
                    ]
                },
                {
                    path: "orders",
                    children: [
                        {
                            path: "",
                            element: <AdminOrderList />,
                        }
                    ]
                },
                {
                    path: "enquiries",
                    children: [
                        {
                            path: "",
                            element: <EnquiryList />,
                        }
                    ]
                }

            ]
        }

    ])

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch('/version.json', { cache: 'no-store' });
                const data = await res.json();
                const storedVersion = localStorage.getItem("app_version");
                if (data.version !== storedVersion) {
                    localStorage.setItem("app_version", data.version);
                    window.location.reload(true);
                }
            } catch (error) {
                console.error("Version check failed:", error);
            }
        };

        checkVersion(); // Run on load

        const interval = setInterval(checkVersion, 5 * 60 * 1000); // Every 5 minutes

        return () => clearInterval(interval);
    }, []);

    return (
        <RouterProvider router={router} />
    );
}

export default App;